import { AxiosInstance } from "axios";

const materialUserTypeServices = (instance: AxiosInstance) => {
  const list = (id_tipo_usuario) =>
    instance
      .get(`/mat-uType?id_tipo_usuario=${id_tipo_usuario}`)
      .then((response: any) => {
        const { result, ...rest } = response.data;
        return [result, rest];
      });

  const update = (id, values) => instance.put("/mat-uType/" + id, values);
  const del = (id) => instance.delete("/mat-uType/" + id);
  const show = (id) =>
    instance.get("/mat-uType/" + id).then((response: any) => {
      const { result, ...rest } = response.data;
      return [result, rest];
    });
  const create = (values) => instance.post("/mat-uType", values);

  return {
    list,
    update,
    del,
    show,
    create,
  };
};
export default materialUserTypeServices;
